
import { StructuredMessageParser } from './StructuredMessageParser';
import { EnhancedMessageContent } from './formatting/EnhancedMessageContent';

interface MessageContentProps {
  content: string;
  isUser: boolean;
}

export function MessageContent({ content, isUser }: MessageContentProps) {
  return <EnhancedMessageContent content={content} isUser={isUser} />;
}
